module.exports = __webpack_public_path__ + "static/img/125.b2d84408.png";